/**
 * Resets explainer + entry to existing Resets engine.
 * Wraps the existing /networker/resets route.
 */
import React from "react";
import PracticeExplainer from "./PracticeExplainer";

export const ResetsIntro = () => (
  <PracticeExplainer
    testId="resets-intro"
    eyebrow="Resets"
    title="Come Back In Seconds"
    accent="rgba(217,180,120,0.62)"
    lines={[
      "Your state changes faster than your thoughts ever could.",
      "Each reset is a 60–90 second doorway back to centre — through breath, body, or sound. No thinking required.",
      "Pick the one that calls to you. Press play. Return.",
    ]}
    cta="Choose A Reset"
    to="/networker/resets"
  />
);

export default ResetsIntro;
